<template>
  <JurnalList jenisJurnal="2" :title="title"  :routeInput="input" :routeEdit="edit" />
</template>

<script>
import JurnalList from '@/views/jurnal/JurnalList.vue';

export default {
    components: {
        JurnalList
    },
    data:() => ({
       title : 'Jurnal Rekening Air',
       input : 'jrainput',
       edit : 'jraedit'
    }),
    methods: {
       
    }
}
</script>


<style>

</style>